/**
 * Smartfactor API
 * API for Smartfactor System
 *
 * The version of the OpenAPI document: 0.4.384
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { RoadOccupationStageAppEntityRoadOccupationStageItemRead } from '../model/roadOccupationStageAppEntityRoadOccupationStageItemRead';
// @ts-ignore
import { RoadOccupationStageAppEntityRoadOccupationStageRead } from '../model/roadOccupationStageAppEntityRoadOccupationStageRead';
// @ts-ignore
import { RoadOccupationStageAppEntityRoadOccupationStageWrite } from '../model/roadOccupationStageAppEntityRoadOccupationStageWrite';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


export interface GetRoadOccupationStageCollectionRoadOccupationStageCollectionRequestParams {
    id?: string;
    id2?: Array<string>;
    startDate?: string;
    startDate2?: string;
    endDate?: string;
    endDate2?: string;
    nextYearsDateFrom?: string;
    nextYearsDateFrom2?: string;
    nextYearsDateTo?: string;
    nextYearsDateTo2?: string;
    nextYearsFrom?: number;
    nextYearsFrom2?: Array<number>;
    nextYearsTo?: number;
    nextYearsTo2?: Array<number>;
    yearsCount?: number;
    yearsCount2?: Array<number>;
    geometry?: string;
    geometry2?: Array<string>;
    roadWidth?: number;
    roadWidth2?: Array<number>;
    roadWidth3?: number;
    roadWidth4?: Array<number>;
    roadWidth5?: number;
    roadWidth6?: Array<number>;
    roadLength?: number;
    roadLength2?: Array<number>;
    roadLength3?: number;
    roadLength4?: Array<number>;
    roadLength5?: number;
    roadLength6?: Array<number>;
    roadArea?: number;
    roadArea2?: Array<number>;
    roadArea3?: number;
    roadArea4?: Array<number>;
    roadArea5?: number;
    roadArea6?: Array<number>;
    roadFee?: number;
    roadFee2?: Array<number>;
    sidewalkWidth?: number;
    sidewalkWidth2?: Array<number>;
    sidewalkLength?: number;
    sidewalkLength2?: Array<number>;
    sidewalkArea?: number;
    sidewalkArea2?: Array<number>;
    sidewalkFee?: number;
    sidewalkFee2?: Array<number>;
    shoulderWidth?: number;
    shoulderWidth2?: Array<number>;
    shoulderLength?: number;
    shoulderLength2?: Array<number>;
    shoulderArea?: number;
    shoulderArea2?: Array<number>;
    shoulderFee?: number;
    shoulderFee2?: Array<number>;
    greeneryWidth?: number;
    greeneryWidth2?: Array<number>;
    greeneryLength?: number;
    greeneryLength2?: Array<number>;
    greeneryArea?: number;
    greeneryArea2?: Array<number>;
    greeneryFee?: number;
    greeneryFee2?: Array<number>;
    otherElementsWidth?: number;
    otherElementsWidth2?: Array<number>;
    otherElementsLength?: number;
    otherElementsLength2?: Array<number>;
    otherElementsArea?: number;
    otherElementsArea2?: Array<number>;
    otherElementsFee?: number;
    otherElementsFee2?: Array<number>;
    roadNumber?: string;
    roadNumber2?: Array<string>;
    roadName?: string;
    roadName2?: Array<string>;
    street?: string;
    street2?: Array<string>;
    sidewalkBikePathParkingBayWidth?: number;
    sidewalkBikePathParkingBayWidth2?: Array<number>;
    sidewalkBikePathParkingBayLength?: number;
    sidewalkBikePathParkingBayLength2?: Array<number>;
    sidewalkBikePathParkingBayArea?: number;
    sidewalkBikePathParkingBayArea2?: Array<number>;
    bikePathWidth?: number;
    bikePathWidth2?: Array<number>;
    bikePathLength?: number;
    bikePathLength2?: Array<number>;
    bikePathArea?: number;
    bikePathArea2?: Array<number>;
    ditchWidth?: number;
    ditchWidth2?: Array<number>;
    ditchLength?: number;
    ditchLength2?: Array<number>;
    ditchArea?: number;
    ditchArea2?: Array<number>;
    roadsideWidth?: number;
    roadsideWidth2?: Array<number>;
    roadsideLength?: number;
    roadsideLength2?: Array<number>;
    roadsideArea?: number;
    roadsideArea2?: Array<number>;
    bridgeStructureWidth?: number;
    bridgeStructureWidth2?: Array<number>;
    bridgeStructureLength?: number;
    bridgeStructureLength2?: Array<number>;
    bridgeStructureArea?: number;
    bridgeStructureArea2?: Array<number>;
    outsideBridgeStructureWidth?: number;
    outsideBridgeStructureWidth2?: Array<number>;
    outsideBridgeStructureLength?: number;
    outsideBridgeStructureLength2?: Array<number>;
    outsideBridgeStructureArea?: number;
    outsideBridgeStructureArea2?: Array<number>;
    infrastructureEquipmentWidth?: number;
    infrastructureEquipmentWidth2?: Array<number>;
    infrastructureEquipmentLength?: number;
    infrastructureEquipmentLength2?: Array<number>;
    infrastructureEquipmentArea?: number;
    infrastructureEquipmentArea2?: Array<number>;
    provideRoadNumberAndName?: boolean;
    provideRoadNumberAndName2?: Array<boolean>;
    infrastructureTelecommunicationOnly?: boolean;
    infrastructureTelecommunicationOnly2?: Array<boolean>;
    ordinalNumber?: number;
    ordinalNumber2?: Array<number>;
    city?: string;
    city2?: Array<string>;
    houseNumber?: string;
    houseNumber2?: Array<string>;
    adKind?: string;
    adKind2?: Array<string>;
    adType?: string;
    adType2?: Array<string>;
    adMountingStructure?: string;
    adMountingStructure2?: Array<string>;
    adLength?: number;
    adLength2?: Array<number>;
    adWidth?: number;
    adWidth2?: Array<number>;
    adArea?: number;
    adArea2?: Array<number>;
    adQuantity?: number;
    adQuantity2?: Array<number>;
    adLightingType?: string;
    adLightingType2?: Array<string>;
    dayQuantity?: number;
    dayQuantity2?: Array<number>;
    adContent?: string;
    adContent2?: Array<string>;
    foreignDeviceLength?: number;
    foreignDeviceLength2?: Array<number>;
    foreignDeviceWidth?: number;
    foreignDeviceWidth2?: Array<number>;
    foreignDeviceArea?: number;
    foreignDeviceArea2?: Array<number>;
    objectsDevicesOccupationWidth?: number;
    objectsDevicesOccupationWidth2?: Array<number>;
    objectsDevicesOccupationLength?: number;
    objectsDevicesOccupationLength2?: Array<number>;
    objectsDevicesOccupationArea?: number;
    objectsDevicesOccupationArea2?: Array<number>;
    devicesCountyRoadsWidth?: number;
    devicesCountyRoadsWidth2?: Array<number>;
    devicesCountyRoadsLength?: number;
    devicesCountyRoadsLength2?: Array<number>;
    devicesCountyRoadsArea?: number;
    devicesCountyRoadsArea2?: Array<number>;
    devicesOnBridgeWidth?: number;
    devicesOnBridgeWidth2?: Array<number>;
    devicesOnBridgeLength?: number;
    devicesOnBridgeLength2?: Array<number>;
    devicesOnBridgeArea?: number;
    devicesOnBridgeArea2?: Array<number>;
    devicesRelatedObjectsWidth?: number;
    devicesRelatedObjectsWidth2?: Array<number>;
    devicesRelatedObjectsLength?: number;
    devicesRelatedObjectsLength2?: Array<number>;
    devicesRelatedObjectsArea?: number;
    devicesRelatedObjectsArea2?: Array<number>;
    devicesProvidePlacementDeadline?: boolean;
    devicesProvidePlacementDeadline2?: Array<boolean>;
    adDoubleSidedWidth?: number;
    adDoubleSidedWidth2?: Array<number>;
    adDoubleSidedLength?: number;
    adDoubleSidedLength2?: Array<number>;
    adDoubleSidedArea?: number;
    adDoubleSidedArea2?: Array<number>;
    createdAt?: string;
    createdAt2?: string;
    updatedAt?: string;
    updatedAt2?: string;
    deletedAt?: string;
    deletedAt2?: string;
    orderOrdinalNumber?: string;
    /** The collection page number */
    page?: number;
    /** The number of items per page */
    itemsPerPage?: number;
    /** Enable or disable pagination */
    pagination?: boolean;
}

export interface GetRoadOccupationStageItemRoadOccupationStageItemRequestParams {
    id: string;
}

export interface PatchRoadOccupationStageRoadOccupationStageItemRequestParams {
    id: string;
    /** The updated RoadOccupationStage resource */
    roadOccupationStage?: RoadOccupationStageAppEntityRoadOccupationStageWrite;
}

export interface PostRoadOccupationStageRoadOccupationStageCollectionRequestParams {
    /** The new RoadOccupationStage resource */
    roadOccupationStage?: RoadOccupationStageAppEntityRoadOccupationStageWrite;
}


@Injectable({
  providedIn: 'root'
})
export class RoadOccupationStageService {

    protected basePath = '/system';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string|string[], @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            const firstBasePath = Array.isArray(basePath) ? basePath[0] : undefined;
            if (firstBasePath != undefined) {
                basePath = firstBasePath;
            }

            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    // @ts-ignore
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Retrieves the collection of RoadOccupationStage resources.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRoadOccupationStageCollectionRoadOccupationStageCollection(requestParameters?: GetRoadOccupationStageCollectionRoadOccupationStageCollectionRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<Array<RoadOccupationStageAppEntityRoadOccupationStageRead>>;
    public getRoadOccupationStageCollectionRoadOccupationStageCollection(requestParameters?: GetRoadOccupationStageCollectionRoadOccupationStageCollectionRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpResponse<Array<RoadOccupationStageAppEntityRoadOccupationStageRead>>>;
    public getRoadOccupationStageCollectionRoadOccupationStageCollection(requestParameters?: GetRoadOccupationStageCollectionRoadOccupationStageCollectionRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpEvent<Array<RoadOccupationStageAppEntityRoadOccupationStageRead>>>;
    public getRoadOccupationStageCollectionRoadOccupationStageCollection(requestParameters?: GetRoadOccupationStageCollectionRoadOccupationStageCollectionRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<any> {
        const id = requestParameters?.id;
        const id2 = requestParameters?.id2;
        const startDate = requestParameters?.startDate;
        const startDate2 = requestParameters?.startDate2;
        const endDate = requestParameters?.endDate;
        const endDate2 = requestParameters?.endDate2;
        const nextYearsDateFrom = requestParameters?.nextYearsDateFrom;
        const nextYearsDateFrom2 = requestParameters?.nextYearsDateFrom2;
        const nextYearsDateTo = requestParameters?.nextYearsDateTo;
        const nextYearsDateTo2 = requestParameters?.nextYearsDateTo2;
        const nextYearsFrom = requestParameters?.nextYearsFrom;
        const nextYearsFrom2 = requestParameters?.nextYearsFrom2;
        const nextYearsTo = requestParameters?.nextYearsTo;
        const nextYearsTo2 = requestParameters?.nextYearsTo2;
        const yearsCount = requestParameters?.yearsCount;
        const yearsCount2 = requestParameters?.yearsCount2;
        const geometry = requestParameters?.geometry;
        const geometry2 = requestParameters?.geometry2;
        const roadWidth = requestParameters?.roadWidth;
        const roadWidth2 = requestParameters?.roadWidth2;
        const roadWidth3 = requestParameters?.roadWidth3;
        const roadWidth4 = requestParameters?.roadWidth4;
        const roadWidth5 = requestParameters?.roadWidth5;
        const roadWidth6 = requestParameters?.roadWidth6;
        const roadLength = requestParameters?.roadLength;
        const roadLength2 = requestParameters?.roadLength2;
        const roadLength3 = requestParameters?.roadLength3;
        const roadLength4 = requestParameters?.roadLength4;
        const roadLength5 = requestParameters?.roadLength5;
        const roadLength6 = requestParameters?.roadLength6;
        const roadArea = requestParameters?.roadArea;
        const roadArea2 = requestParameters?.roadArea2;
        const roadArea3 = requestParameters?.roadArea3;
        const roadArea4 = requestParameters?.roadArea4;
        const roadArea5 = requestParameters?.roadArea5;
        const roadArea6 = requestParameters?.roadArea6;
        const roadFee = requestParameters?.roadFee;
        const roadFee2 = requestParameters?.roadFee2;
        const sidewalkWidth = requestParameters?.sidewalkWidth;
        const sidewalkWidth2 = requestParameters?.sidewalkWidth2;
        const sidewalkLength = requestParameters?.sidewalkLength;
        const sidewalkLength2 = requestParameters?.sidewalkLength2;
        const sidewalkArea = requestParameters?.sidewalkArea;
        const sidewalkArea2 = requestParameters?.sidewalkArea2;
        const sidewalkFee = requestParameters?.sidewalkFee;
        const sidewalkFee2 = requestParameters?.sidewalkFee2;
        const shoulderWidth = requestParameters?.shoulderWidth;
        const shoulderWidth2 = requestParameters?.shoulderWidth2;
        const shoulderLength = requestParameters?.shoulderLength;
        const shoulderLength2 = requestParameters?.shoulderLength2;
        const shoulderArea = requestParameters?.shoulderArea;
        const shoulderArea2 = requestParameters?.shoulderArea2;
        const shoulderFee = requestParameters?.shoulderFee;
        const shoulderFee2 = requestParameters?.shoulderFee2;
        const greeneryWidth = requestParameters?.greeneryWidth;
        const greeneryWidth2 = requestParameters?.greeneryWidth2;
        const greeneryLength = requestParameters?.greeneryLength;
        const greeneryLength2 = requestParameters?.greeneryLength2;
        const greeneryArea = requestParameters?.greeneryArea;
        const greeneryArea2 = requestParameters?.greeneryArea2;
        const greeneryFee = requestParameters?.greeneryFee;
        const greeneryFee2 = requestParameters?.greeneryFee2;
        const otherElementsWidth = requestParameters?.otherElementsWidth;
        const otherElementsWidth2 = requestParameters?.otherElementsWidth2;
        const otherElementsLength = requestParameters?.otherElementsLength;
        const otherElementsLength2 = requestParameters?.otherElementsLength2;
        const otherElementsArea = requestParameters?.otherElementsArea;
        const otherElementsArea2 = requestParameters?.otherElementsArea2;
        const otherElementsFee = requestParameters?.otherElementsFee;
        const otherElementsFee2 = requestParameters?.otherElementsFee2;
        const roadNumber = requestParameters?.roadNumber;
        const roadNumber2 = requestParameters?.roadNumber2;
        const roadName = requestParameters?.roadName;
        const roadName2 = requestParameters?.roadName2;
        const street = requestParameters?.street;
        const street2 = requestParameters?.street2;
        const sidewalkBikePathParkingBayWidth = requestParameters?.sidewalkBikePathParkingBayWidth;
        const sidewalkBikePathParkingBayWidth2 = requestParameters?.sidewalkBikePathParkingBayWidth2;
        const sidewalkBikePathParkingBayLength = requestParameters?.sidewalkBikePathParkingBayLength;
        const sidewalkBikePathParkingBayLength2 = requestParameters?.sidewalkBikePathParkingBayLength2;
        const sidewalkBikePathParkingBayArea = requestParameters?.sidewalkBikePathParkingBayArea;
        const sidewalkBikePathParkingBayArea2 = requestParameters?.sidewalkBikePathParkingBayArea2;
        const bikePathWidth = requestParameters?.bikePathWidth;
        const bikePathWidth2 = requestParameters?.bikePathWidth2;
        const bikePathLength = requestParameters?.bikePathLength;
        const bikePathLength2 = requestParameters?.bikePathLength2;
        const bikePathArea = requestParameters?.bikePathArea;
        const bikePathArea2 = requestParameters?.bikePathArea2;
        const ditchWidth = requestParameters?.ditchWidth;
        const ditchWidth2 = requestParameters?.ditchWidth2;
        const ditchLength = requestParameters?.ditchLength;
        const ditchLength2 = requestParameters?.ditchLength2;
        const ditchArea = requestParameters?.ditchArea;
        const ditchArea2 = requestParameters?.ditchArea2;
        const roadsideWidth = requestParameters?.roadsideWidth;
        const roadsideWidth2 = requestParameters?.roadsideWidth2;
        const roadsideLength = requestParameters?.roadsideLength;
        const roadsideLength2 = requestParameters?.roadsideLength2;
        const roadsideArea = requestParameters?.roadsideArea;
        const roadsideArea2 = requestParameters?.roadsideArea2;
        const bridgeStructureWidth = requestParameters?.bridgeStructureWidth;
        const bridgeStructureWidth2 = requestParameters?.bridgeStructureWidth2;
        const bridgeStructureLength = requestParameters?.bridgeStructureLength;
        const bridgeStructureLength2 = requestParameters?.bridgeStructureLength2;
        const bridgeStructureArea = requestParameters?.bridgeStructureArea;
        const bridgeStructureArea2 = requestParameters?.bridgeStructureArea2;
        const outsideBridgeStructureWidth = requestParameters?.outsideBridgeStructureWidth;
        const outsideBridgeStructureWidth2 = requestParameters?.outsideBridgeStructureWidth2;
        const outsideBridgeStructureLength = requestParameters?.outsideBridgeStructureLength;
        const outsideBridgeStructureLength2 = requestParameters?.outsideBridgeStructureLength2;
        const outsideBridgeStructureArea = requestParameters?.outsideBridgeStructureArea;
        const outsideBridgeStructureArea2 = requestParameters?.outsideBridgeStructureArea2;
        const infrastructureEquipmentWidth = requestParameters?.infrastructureEquipmentWidth;
        const infrastructureEquipmentWidth2 = requestParameters?.infrastructureEquipmentWidth2;
        const infrastructureEquipmentLength = requestParameters?.infrastructureEquipmentLength;
        const infrastructureEquipmentLength2 = requestParameters?.infrastructureEquipmentLength2;
        const infrastructureEquipmentArea = requestParameters?.infrastructureEquipmentArea;
        const infrastructureEquipmentArea2 = requestParameters?.infrastructureEquipmentArea2;
        const provideRoadNumberAndName = requestParameters?.provideRoadNumberAndName;
        const provideRoadNumberAndName2 = requestParameters?.provideRoadNumberAndName2;
        const infrastructureTelecommunicationOnly = requestParameters?.infrastructureTelecommunicationOnly;
        const infrastructureTelecommunicationOnly2 = requestParameters?.infrastructureTelecommunicationOnly2;
        const ordinalNumber = requestParameters?.ordinalNumber;
        const ordinalNumber2 = requestParameters?.ordinalNumber2;
        const city = requestParameters?.city;
        const city2 = requestParameters?.city2;
        const houseNumber = requestParameters?.houseNumber;
        const houseNumber2 = requestParameters?.houseNumber2;
        const adKind = requestParameters?.adKind;
        const adKind2 = requestParameters?.adKind2;
        const adType = requestParameters?.adType;
        const adType2 = requestParameters?.adType2;
        const adMountingStructure = requestParameters?.adMountingStructure;
        const adMountingStructure2 = requestParameters?.adMountingStructure2;
        const adLength = requestParameters?.adLength;
        const adLength2 = requestParameters?.adLength2;
        const adWidth = requestParameters?.adWidth;
        const adWidth2 = requestParameters?.adWidth2;
        const adArea = requestParameters?.adArea;
        const adArea2 = requestParameters?.adArea2;
        const adQuantity = requestParameters?.adQuantity;
        const adQuantity2 = requestParameters?.adQuantity2;
        const adLightingType = requestParameters?.adLightingType;
        const adLightingType2 = requestParameters?.adLightingType2;
        const dayQuantity = requestParameters?.dayQuantity;
        const dayQuantity2 = requestParameters?.dayQuantity2;
        const adContent = requestParameters?.adContent;
        const adContent2 = requestParameters?.adContent2;
        const foreignDeviceLength = requestParameters?.foreignDeviceLength;
        const foreignDeviceLength2 = requestParameters?.foreignDeviceLength2;
        const foreignDeviceWidth = requestParameters?.foreignDeviceWidth;
        const foreignDeviceWidth2 = requestParameters?.foreignDeviceWidth2;
        const foreignDeviceArea = requestParameters?.foreignDeviceArea;
        const foreignDeviceArea2 = requestParameters?.foreignDeviceArea2;
        const objectsDevicesOccupationWidth = requestParameters?.objectsDevicesOccupationWidth;
        const objectsDevicesOccupationWidth2 = requestParameters?.objectsDevicesOccupationWidth2;
        const objectsDevicesOccupationLength = requestParameters?.objectsDevicesOccupationLength;
        const objectsDevicesOccupationLength2 = requestParameters?.objectsDevicesOccupationLength2;
        const objectsDevicesOccupationArea = requestParameters?.objectsDevicesOccupationArea;
        const objectsDevicesOccupationArea2 = requestParameters?.objectsDevicesOccupationArea2;
        const devicesCountyRoadsWidth = requestParameters?.devicesCountyRoadsWidth;
        const devicesCountyRoadsWidth2 = requestParameters?.devicesCountyRoadsWidth2;
        const devicesCountyRoadsLength = requestParameters?.devicesCountyRoadsLength;
        const devicesCountyRoadsLength2 = requestParameters?.devicesCountyRoadsLength2;
        const devicesCountyRoadsArea = requestParameters?.devicesCountyRoadsArea;
        const devicesCountyRoadsArea2 = requestParameters?.devicesCountyRoadsArea2;
        const devicesOnBridgeWidth = requestParameters?.devicesOnBridgeWidth;
        const devicesOnBridgeWidth2 = requestParameters?.devicesOnBridgeWidth2;
        const devicesOnBridgeLength = requestParameters?.devicesOnBridgeLength;
        const devicesOnBridgeLength2 = requestParameters?.devicesOnBridgeLength2;
        const devicesOnBridgeArea = requestParameters?.devicesOnBridgeArea;
        const devicesOnBridgeArea2 = requestParameters?.devicesOnBridgeArea2;
        const devicesRelatedObjectsWidth = requestParameters?.devicesRelatedObjectsWidth;
        const devicesRelatedObjectsWidth2 = requestParameters?.devicesRelatedObjectsWidth2;
        const devicesRelatedObjectsLength = requestParameters?.devicesRelatedObjectsLength;
        const devicesRelatedObjectsLength2 = requestParameters?.devicesRelatedObjectsLength2;
        const devicesRelatedObjectsArea = requestParameters?.devicesRelatedObjectsArea;
        const devicesRelatedObjectsArea2 = requestParameters?.devicesRelatedObjectsArea2;
        const devicesProvidePlacementDeadline = requestParameters?.devicesProvidePlacementDeadline;
        const devicesProvidePlacementDeadline2 = requestParameters?.devicesProvidePlacementDeadline2;
        const adDoubleSidedWidth = requestParameters?.adDoubleSidedWidth;
        const adDoubleSidedWidth2 = requestParameters?.adDoubleSidedWidth2;
        const adDoubleSidedLength = requestParameters?.adDoubleSidedLength;
        const adDoubleSidedLength2 = requestParameters?.adDoubleSidedLength2;
        const adDoubleSidedArea = requestParameters?.adDoubleSidedArea;
        const adDoubleSidedArea2 = requestParameters?.adDoubleSidedArea2;
        const createdAt = requestParameters?.createdAt;
        const createdAt2 = requestParameters?.createdAt2;
        const updatedAt = requestParameters?.updatedAt;
        const updatedAt2 = requestParameters?.updatedAt2;
        const deletedAt = requestParameters?.deletedAt;
        const deletedAt2 = requestParameters?.deletedAt2;
        const orderOrdinalNumber = requestParameters?.orderOrdinalNumber;
        const page = requestParameters?.page;
        const itemsPerPage = requestParameters?.itemsPerPage;
        const pagination = requestParameters?.pagination;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (id !== undefined && id !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>id, 'id');
        }
        if (id2) {
            id2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'id[]');
            })
        }
        if (startDate !== undefined && startDate !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>startDate, 'startDate');
        }
        if (startDate2 !== undefined && startDate2 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>startDate2, 'startDate[]');
        }
        if (endDate !== undefined && endDate !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>endDate, 'endDate');
        }
        if (endDate2 !== undefined && endDate2 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>endDate2, 'endDate[]');
        }
        if (nextYearsDateFrom !== undefined && nextYearsDateFrom !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>nextYearsDateFrom, 'nextYearsDateFrom');
        }
        if (nextYearsDateFrom2 !== undefined && nextYearsDateFrom2 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>nextYearsDateFrom2, 'nextYearsDateFrom[]');
        }
        if (nextYearsDateTo !== undefined && nextYearsDateTo !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>nextYearsDateTo, 'nextYearsDateTo');
        }
        if (nextYearsDateTo2 !== undefined && nextYearsDateTo2 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>nextYearsDateTo2, 'nextYearsDateTo[]');
        }
        if (nextYearsFrom !== undefined && nextYearsFrom !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>nextYearsFrom, 'nextYearsFrom');
        }
        if (nextYearsFrom2) {
            nextYearsFrom2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'nextYearsFrom[]');
            })
        }
        if (nextYearsTo !== undefined && nextYearsTo !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>nextYearsTo, 'nextYearsTo');
        }
        if (nextYearsTo2) {
            nextYearsTo2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'nextYearsTo[]');
            })
        }
        if (yearsCount !== undefined && yearsCount !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>yearsCount, 'yearsCount');
        }
        if (yearsCount2) {
            yearsCount2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'yearsCount[]');
            })
        }
        if (geometry !== undefined && geometry !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>geometry, 'geometry');
        }
        if (geometry2) {
            geometry2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'geometry[]');
            })
        }
        if (roadWidth !== undefined && roadWidth !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>roadWidth, 'roadWidth');
        }
        if (roadWidth2) {
            roadWidth2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'roadWidth[]');
            })
        }
        if (roadWidth3 !== undefined && roadWidth3 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>roadWidth3, 'roadWidth2');
        }
        if (roadWidth4) {
            roadWidth4.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'roadWidth2[]');
            })
        }
        if (roadWidth5 !== undefined && roadWidth5 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>roadWidth5, 'roadWidth3');
        }
        if (roadWidth6) {
            roadWidth6.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'roadWidth3[]');
            })
        }
        if (roadLength !== undefined && roadLength !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>roadLength, 'roadLength');
        }
        if (roadLength2) {
            roadLength2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'roadLength[]');
            })
        }
        if (roadLength3 !== undefined && roadLength3 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>roadLength3, 'roadLength2');
        }
        if (roadLength4) {
            roadLength4.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'roadLength2[]');
            })
        }
        if (roadLength5 !== undefined && roadLength5 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>roadLength5, 'roadLength3');
        }
        if (roadLength6) {
            roadLength6.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'roadLength3[]');
            })
        }
        if (roadArea !== undefined && roadArea !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>roadArea, 'roadArea');
        }
        if (roadArea2) {
            roadArea2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'roadArea[]');
            })
        }
        if (roadArea3 !== undefined && roadArea3 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>roadArea3, 'roadArea2');
        }
        if (roadArea4) {
            roadArea4.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'roadArea2[]');
            })
        }
        if (roadArea5 !== undefined && roadArea5 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>roadArea5, 'roadArea3');
        }
        if (roadArea6) {
            roadArea6.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'roadArea3[]');
            })
        }
        if (roadFee !== undefined && roadFee !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>roadFee, 'roadFee');
        }
        if (roadFee2) {
            roadFee2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'roadFee[]');
            })
        }
        if (sidewalkWidth !== undefined && sidewalkWidth !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>sidewalkWidth, 'sidewalkWidth');
        }
        if (sidewalkWidth2) {
            sidewalkWidth2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'sidewalkWidth[]');
            })
        }
        if (sidewalkLength !== undefined && sidewalkLength !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>sidewalkLength, 'sidewalkLength');
        }
        if (sidewalkLength2) {
            sidewalkLength2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'sidewalkLength[]');
            })
        }
        if (sidewalkArea !== undefined && sidewalkArea !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>sidewalkArea, 'sidewalkArea');
        }
        if (sidewalkArea2) {
            sidewalkArea2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'sidewalkArea[]');
            })
        }
        if (sidewalkFee !== undefined && sidewalkFee !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>sidewalkFee, 'sidewalkFee');
        }
        if (sidewalkFee2) {
            sidewalkFee2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'sidewalkFee[]');
            })
        }
        if (shoulderWidth !== undefined && shoulderWidth !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>shoulderWidth, 'shoulderWidth');
        }
        if (shoulderWidth2) {
            shoulderWidth2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'shoulderWidth[]');
            })
        }
        if (shoulderLength !== undefined && shoulderLength !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>shoulderLength, 'shoulderLength');
        }
        if (shoulderLength2) {
            shoulderLength2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'shoulderLength[]');
            })
        }
        if (shoulderArea !== undefined && shoulderArea !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>shoulderArea, 'shoulderArea');
        }
        if (shoulderArea2) {
            shoulderArea2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'shoulderArea[]');
            })
        }
        if (shoulderFee !== undefined && shoulderFee !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>shoulderFee, 'shoulderFee');
        }
        if (shoulderFee2) {
            shoulderFee2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'shoulderFee[]');
            })
        }
        if (greeneryWidth !== undefined && greeneryWidth !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>greeneryWidth, 'greeneryWidth');
        }
        if (greeneryWidth2) {
            greeneryWidth2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'greeneryWidth[]');
            })
        }
        if (greeneryLength !== undefined && greeneryLength !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>greeneryLength, 'greeneryLength');
        }
        if (greeneryLength2) {
            greeneryLength2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'greeneryLength[]');
            })
        }
        if (greeneryArea !== undefined && greeneryArea !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>greeneryArea, 'greeneryArea');
        }
        if (greeneryArea2) {
            greeneryArea2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'greeneryArea[]');
            })
        }
        if (greeneryFee !== undefined && greeneryFee !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>greeneryFee, 'greeneryFee');
        }
        if (greeneryFee2) {
            greeneryFee2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'greeneryFee[]');
            })
        }
        if (otherElementsWidth !== undefined && otherElementsWidth !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>otherElementsWidth, 'otherElementsWidth');
        }
        if (otherElementsWidth2) {
            otherElementsWidth2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'otherElementsWidth[]');
            })
        }
        if (otherElementsLength !== undefined && otherElementsLength !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>otherElementsLength, 'otherElementsLength');
        }
        if (otherElementsLength2) {
            otherElementsLength2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'otherElementsLength[]');
            })
        }
        if (otherElementsArea !== undefined && otherElementsArea !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>otherElementsArea, 'otherElementsArea');
        }
        if (otherElementsArea2) {
            otherElementsArea2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'otherElementsArea[]');
            })
        }
        if (otherElementsFee !== undefined && otherElementsFee !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>otherElementsFee, 'otherElementsFee');
        }
        if (otherElementsFee2) {
            otherElementsFee2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'otherElementsFee[]');
            })
        }
        if (roadNumber !== undefined && roadNumber !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>roadNumber, 'roadNumber');
        }
        if (roadNumber2) {
            roadNumber2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'roadNumber[]');
            })
        }
        if (roadName !== undefined && roadName !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>roadName, 'roadName');
        }
        if (roadName2) {
            roadName2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'roadName[]');
            })
        }
        if (street !== undefined && street !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>street, 'street');
        }
        if (street2) {
            street2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'street[]');
            })
        }
        if (sidewalkBikePathParkingBayWidth !== undefined && sidewalkBikePathParkingBayWidth !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>sidewalkBikePathParkingBayWidth, 'sidewalkBikePathParkingBayWidth');
        }
        if (sidewalkBikePathParkingBayWidth2) {
            sidewalkBikePathParkingBayWidth2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'sidewalkBikePathParkingBayWidth[]');
            })
        }
        if (sidewalkBikePathParkingBayLength !== undefined && sidewalkBikePathParkingBayLength !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>sidewalkBikePathParkingBayLength, 'sidewalkBikePathParkingBayLength');
        }
        if (sidewalkBikePathParkingBayLength2) {
            sidewalkBikePathParkingBayLength2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'sidewalkBikePathParkingBayLength[]');
            })
        }
        if (sidewalkBikePathParkingBayArea !== undefined && sidewalkBikePathParkingBayArea !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>sidewalkBikePathParkingBayArea, 'sidewalkBikePathParkingBayArea');
        }
        if (sidewalkBikePathParkingBayArea2) {
            sidewalkBikePathParkingBayArea2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'sidewalkBikePathParkingBayArea[]');
            })
        }
        if (bikePathWidth !== undefined && bikePathWidth !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>bikePathWidth, 'bikePathWidth');
        }
        if (bikePathWidth2) {
            bikePathWidth2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'bikePathWidth[]');
            })
        }
        if (bikePathLength !== undefined && bikePathLength !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>bikePathLength, 'bikePathLength');
        }
        if (bikePathLength2) {
            bikePathLength2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'bikePathLength[]');
            })
        }
        if (bikePathArea !== undefined && bikePathArea !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>bikePathArea, 'bikePathArea');
        }
        if (bikePathArea2) {
            bikePathArea2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'bikePathArea[]');
            })
        }
        if (ditchWidth !== undefined && ditchWidth !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>ditchWidth, 'ditchWidth');
        }
        if (ditchWidth2) {
            ditchWidth2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'ditchWidth[]');
            })
        }
        if (ditchLength !== undefined && ditchLength !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>ditchLength, 'ditchLength');
        }
        if (ditchLength2) {
            ditchLength2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'ditchLength[]');
            })
        }
        if (ditchArea !== undefined && ditchArea !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>ditchArea, 'ditchArea');
        }
        if (ditchArea2) {
            ditchArea2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'ditchArea[]');
            })
        }
        if (roadsideWidth !== undefined && roadsideWidth !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>roadsideWidth, 'roadsideWidth');
        }
        if (roadsideWidth2) {
            roadsideWidth2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'roadsideWidth[]');
            })
        }
        if (roadsideLength !== undefined && roadsideLength !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>roadsideLength, 'roadsideLength');
        }
        if (roadsideLength2) {
            roadsideLength2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'roadsideLength[]');
            })
        }
        if (roadsideArea !== undefined && roadsideArea !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>roadsideArea, 'roadsideArea');
        }
        if (roadsideArea2) {
            roadsideArea2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'roadsideArea[]');
            })
        }
        if (bridgeStructureWidth !== undefined && bridgeStructureWidth !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>bridgeStructureWidth, 'bridgeStructureWidth');
        }
        if (bridgeStructureWidth2) {
            bridgeStructureWidth2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'bridgeStructureWidth[]');
            })
        }
        if (bridgeStructureLength !== undefined && bridgeStructureLength !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>bridgeStructureLength, 'bridgeStructureLength');
        }
        if (bridgeStructureLength2) {
            bridgeStructureLength2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'bridgeStructureLength[]');
            })
        }
        if (bridgeStructureArea !== undefined && bridgeStructureArea !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>bridgeStructureArea, 'bridgeStructureArea');
        }
        if (bridgeStructureArea2) {
            bridgeStructureArea2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'bridgeStructureArea[]');
            })
        }
        if (outsideBridgeStructureWidth !== undefined && outsideBridgeStructureWidth !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>outsideBridgeStructureWidth, 'outsideBridgeStructureWidth');
        }
        if (outsideBridgeStructureWidth2) {
            outsideBridgeStructureWidth2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'outsideBridgeStructureWidth[]');
            })
        }
        if (outsideBridgeStructureLength !== undefined && outsideBridgeStructureLength !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>outsideBridgeStructureLength, 'outsideBridgeStructureLength');
        }
        if (outsideBridgeStructureLength2) {
            outsideBridgeStructureLength2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'outsideBridgeStructureLength[]');
            })
        }
        if (outsideBridgeStructureArea !== undefined && outsideBridgeStructureArea !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>outsideBridgeStructureArea, 'outsideBridgeStructureArea');
        }
        if (outsideBridgeStructureArea2) {
            outsideBridgeStructureArea2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'outsideBridgeStructureArea[]');
            })
        }
        if (infrastructureEquipmentWidth !== undefined && infrastructureEquipmentWidth !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>infrastructureEquipmentWidth, 'infrastructureEquipmentWidth');
        }
        if (infrastructureEquipmentWidth2) {
            infrastructureEquipmentWidth2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'infrastructureEquipmentWidth[]');
            })
        }
        if (infrastructureEquipmentLength !== undefined && infrastructureEquipmentLength !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>infrastructureEquipmentLength, 'infrastructureEquipmentLength');
        }
        if (infrastructureEquipmentLength2) {
            infrastructureEquipmentLength2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'infrastructureEquipmentLength[]');
            })
        }
        if (infrastructureEquipmentArea !== undefined && infrastructureEquipmentArea !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>infrastructureEquipmentArea, 'infrastructureEquipmentArea');
        }
        if (infrastructureEquipmentArea2) {
            infrastructureEquipmentArea2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'infrastructureEquipmentArea[]');
            })
        }
        if (provideRoadNumberAndName !== undefined && provideRoadNumberAndName !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>provideRoadNumberAndName, 'provideRoadNumberAndName');
        }
        if (provideRoadNumberAndName2) {
            provideRoadNumberAndName2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'provideRoadNumberAndName[]');
            })
        }
        if (infrastructureTelecommunicationOnly !== undefined && infrastructureTelecommunicationOnly !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>infrastructureTelecommunicationOnly, 'infrastructureTelecommunicationOnly');
        }
        if (infrastructureTelecommunicationOnly2) {
            infrastructureTelecommunicationOnly2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'infrastructureTelecommunicationOnly[]');
            })
        }
        if (ordinalNumber !== undefined && ordinalNumber !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>ordinalNumber, 'ordinalNumber');
        }
        if (ordinalNumber2) {
            ordinalNumber2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'ordinalNumber[]');
            })
        }
        if (city !== undefined && city !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>city, 'city');
        }
        if (city2) {
            city2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'city[]');
            })
        }
        if (houseNumber !== undefined && houseNumber !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>houseNumber, 'houseNumber');
        }
        if (houseNumber2) {
            houseNumber2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'houseNumber[]');
            })
        }
        if (adKind !== undefined && adKind !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>adKind, 'adKind');
        }
        if (adKind2) {
            adKind2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'adKind[]');
            })
        }
        if (adType !== undefined && adType !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>adType, 'adType');
        }
        if (adType2) {
            adType2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'adType[]');
            })
        }
        if (adMountingStructure !== undefined && adMountingStructure !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>adMountingStructure, 'adMountingStructure');
        }
        if (adMountingStructure2) {
            adMountingStructure2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'adMountingStructure[]');
            })
        }
        if (adLength !== undefined && adLength !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>adLength, 'adLength');
        }
        if (adLength2) {
            adLength2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'adLength[]');
            })
        }
        if (adWidth !== undefined && adWidth !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>adWidth, 'adWidth');
        }
        if (adWidth2) {
            adWidth2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'adWidth[]');
            })
        }
        if (adArea !== undefined && adArea !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>adArea, 'adArea');
        }
        if (adArea2) {
            adArea2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'adArea[]');
            })
        }
        if (adQuantity !== undefined && adQuantity !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>adQuantity, 'adQuantity');
        }
        if (adQuantity2) {
            adQuantity2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'adQuantity[]');
            })
        }
        if (adLightingType !== undefined && adLightingType !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>adLightingType, 'adLightingType');
        }
        if (adLightingType2) {
            adLightingType2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'adLightingType[]');
            })
        }
        if (dayQuantity !== undefined && dayQuantity !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>dayQuantity, 'dayQuantity');
        }
        if (dayQuantity2) {
            dayQuantity2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'dayQuantity[]');
            })
        }
        if (adContent !== undefined && adContent !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>adContent, 'adContent');
        }
        if (adContent2) {
            adContent2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'adContent[]');
            })
        }
        if (foreignDeviceLength !== undefined && foreignDeviceLength !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>foreignDeviceLength, 'foreignDeviceLength');
        }
        if (foreignDeviceLength2) {
            foreignDeviceLength2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'foreignDeviceLength[]');
            })
        }
        if (foreignDeviceWidth !== undefined && foreignDeviceWidth !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>foreignDeviceWidth, 'foreignDeviceWidth');
        }
        if (foreignDeviceWidth2) {
            foreignDeviceWidth2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'foreignDeviceWidth[]');
            })
        }
        if (foreignDeviceArea !== undefined && foreignDeviceArea !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>foreignDeviceArea, 'foreignDeviceArea');
        }
        if (foreignDeviceArea2) {
            foreignDeviceArea2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'foreignDeviceArea[]');
            })
        }
        if (objectsDevicesOccupationWidth !== undefined && objectsDevicesOccupationWidth !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>objectsDevicesOccupationWidth, 'objectsDevicesOccupationWidth');
        }
        if (objectsDevicesOccupationWidth2) {
            objectsDevicesOccupationWidth2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'objectsDevicesOccupationWidth[]');
            })
        }
        if (objectsDevicesOccupationLength !== undefined && objectsDevicesOccupationLength !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>objectsDevicesOccupationLength, 'objectsDevicesOccupationLength');
        }
        if (objectsDevicesOccupationLength2) {
            objectsDevicesOccupationLength2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'objectsDevicesOccupationLength[]');
            })
        }
        if (objectsDevicesOccupationArea !== undefined && objectsDevicesOccupationArea !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>objectsDevicesOccupationArea, 'objectsDevicesOccupationArea');
        }
        if (objectsDevicesOccupationArea2) {
            objectsDevicesOccupationArea2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'objectsDevicesOccupationArea[]');
            })
        }
        if (devicesCountyRoadsWidth !== undefined && devicesCountyRoadsWidth !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>devicesCountyRoadsWidth, 'devicesCountyRoadsWidth');
        }
        if (devicesCountyRoadsWidth2) {
            devicesCountyRoadsWidth2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'devicesCountyRoadsWidth[]');
            })
        }
        if (devicesCountyRoadsLength !== undefined && devicesCountyRoadsLength !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>devicesCountyRoadsLength, 'devicesCountyRoadsLength');
        }
        if (devicesCountyRoadsLength2) {
            devicesCountyRoadsLength2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'devicesCountyRoadsLength[]');
            })
        }
        if (devicesCountyRoadsArea !== undefined && devicesCountyRoadsArea !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>devicesCountyRoadsArea, 'devicesCountyRoadsArea');
        }
        if (devicesCountyRoadsArea2) {
            devicesCountyRoadsArea2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'devicesCountyRoadsArea[]');
            })
        }
        if (devicesOnBridgeWidth !== undefined && devicesOnBridgeWidth !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>devicesOnBridgeWidth, 'devicesOnBridgeWidth');
        }
        if (devicesOnBridgeWidth2) {
            devicesOnBridgeWidth2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'devicesOnBridgeWidth[]');
            })
        }
        if (devicesOnBridgeLength !== undefined && devicesOnBridgeLength !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>devicesOnBridgeLength, 'devicesOnBridgeLength');
        }
        if (devicesOnBridgeLength2) {
            devicesOnBridgeLength2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'devicesOnBridgeLength[]');
            })
        }
        if (devicesOnBridgeArea !== undefined && devicesOnBridgeArea !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>devicesOnBridgeArea, 'devicesOnBridgeArea');
        }
        if (devicesOnBridgeArea2) {
            devicesOnBridgeArea2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'devicesOnBridgeArea[]');
            })
        }
        if (devicesRelatedObjectsWidth !== undefined && devicesRelatedObjectsWidth !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>devicesRelatedObjectsWidth, 'devicesRelatedObjectsWidth');
        }
        if (devicesRelatedObjectsWidth2) {
            devicesRelatedObjectsWidth2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'devicesRelatedObjectsWidth[]');
            })
        }
        if (devicesRelatedObjectsLength !== undefined && devicesRelatedObjectsLength !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>devicesRelatedObjectsLength, 'devicesRelatedObjectsLength');
        }
        if (devicesRelatedObjectsLength2) {
            devicesRelatedObjectsLength2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'devicesRelatedObjectsLength[]');
            })
        }
        if (devicesRelatedObjectsArea !== undefined && devicesRelatedObjectsArea !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>devicesRelatedObjectsArea, 'devicesRelatedObjectsArea');
        }
        if (devicesRelatedObjectsArea2) {
            devicesRelatedObjectsArea2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'devicesRelatedObjectsArea[]');
            })
        }
        if (devicesProvidePlacementDeadline !== undefined && devicesProvidePlacementDeadline !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>devicesProvidePlacementDeadline, 'devicesProvidePlacementDeadline');
        }
        if (devicesProvidePlacementDeadline2) {
            devicesProvidePlacementDeadline2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'devicesProvidePlacementDeadline[]');
            })
        }
        if (adDoubleSidedWidth !== undefined && adDoubleSidedWidth !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>adDoubleSidedWidth, 'adDoubleSidedWidth');
        }
        if (adDoubleSidedWidth2) {
            adDoubleSidedWidth2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'adDoubleSidedWidth[]');
            })
        }
        if (adDoubleSidedLength !== undefined && adDoubleSidedLength !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>adDoubleSidedLength, 'adDoubleSidedLength');
        }
        if (adDoubleSidedLength2) {
            adDoubleSidedLength2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'adDoubleSidedLength[]');
            })
        }
        if (adDoubleSidedArea !== undefined && adDoubleSidedArea !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>adDoubleSidedArea, 'adDoubleSidedArea');
        }
        if (adDoubleSidedArea2) {
            adDoubleSidedArea2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'adDoubleSidedArea[]');
            })
        }
        if (createdAt !== undefined && createdAt !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>createdAt, 'createdAt');
        }
        if (createdAt2 !== undefined && createdAt2 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>createdAt2, 'createdAt[]');
        }
        if (updatedAt !== undefined && updatedAt !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>updatedAt, 'updatedAt');
        }
        if (updatedAt2 !== undefined && updatedAt2 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>updatedAt2, 'updatedAt[]');
        }
        if (deletedAt !== undefined && deletedAt !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>deletedAt, 'deletedAt');
        }
        if (deletedAt2 !== undefined && deletedAt2 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>deletedAt2, 'deletedAt[]');
        }
        if (orderOrdinalNumber !== undefined && orderOrdinalNumber !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>orderOrdinalNumber, 'order[ordinalNumber]');
        }
        if (page !== undefined && page !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>page, 'page');
        }
        if (itemsPerPage !== undefined && itemsPerPage !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>itemsPerPage, 'itemsPerPage');
        }
        if (pagination !== undefined && pagination !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>pagination, 'pagination');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKey) required
        localVarCredential = this.configuration.lookupCredential('apiKey');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/ld+json',
                'text/html',
                'application/octet-stream'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/road_occupation_stages`;
        return this.httpClient.request<Array<RoadOccupationStageAppEntityRoadOccupationStageRead>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieves a RoadOccupationStage resource.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRoadOccupationStageItemRoadOccupationStageItem(requestParameters?: GetRoadOccupationStageItemRoadOccupationStageItemRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<RoadOccupationStageAppEntityRoadOccupationStageItemRead>;
    public getRoadOccupationStageItemRoadOccupationStageItem(requestParameters?: GetRoadOccupationStageItemRoadOccupationStageItemRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpResponse<RoadOccupationStageAppEntityRoadOccupationStageItemRead>>;
    public getRoadOccupationStageItemRoadOccupationStageItem(requestParameters?: GetRoadOccupationStageItemRoadOccupationStageItemRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpEvent<RoadOccupationStageAppEntityRoadOccupationStageItemRead>>;
    public getRoadOccupationStageItemRoadOccupationStageItem(requestParameters?: GetRoadOccupationStageItemRoadOccupationStageItemRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<any> {
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getRoadOccupationStageItemRoadOccupationStageItem.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKey) required
        localVarCredential = this.configuration.lookupCredential('apiKey');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/ld+json',
                'text/html',
                'application/octet-stream'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/road_occupation_stages/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<RoadOccupationStageAppEntityRoadOccupationStageItemRead>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates the RoadOccupationStage resource.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patchRoadOccupationStageRoadOccupationStageItem(requestParameters?: PatchRoadOccupationStageRoadOccupationStageItemRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<RoadOccupationStageAppEntityRoadOccupationStageRead>;
    public patchRoadOccupationStageRoadOccupationStageItem(requestParameters?: PatchRoadOccupationStageRoadOccupationStageItemRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpResponse<RoadOccupationStageAppEntityRoadOccupationStageRead>>;
    public patchRoadOccupationStageRoadOccupationStageItem(requestParameters?: PatchRoadOccupationStageRoadOccupationStageItemRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpEvent<RoadOccupationStageAppEntityRoadOccupationStageRead>>;
    public patchRoadOccupationStageRoadOccupationStageItem(requestParameters?: PatchRoadOccupationStageRoadOccupationStageItemRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<any> {
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling patchRoadOccupationStageRoadOccupationStageItem.');
        }
        const roadOccupationStage = requestParameters?.roadOccupationStage;

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKey) required
        localVarCredential = this.configuration.lookupCredential('apiKey');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/ld+json',
                'text/html',
                'application/octet-stream'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/merge-patch+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/road_occupation_stages/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<RoadOccupationStageAppEntityRoadOccupationStageRead>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: roadOccupationStage,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Creates a RoadOccupationStage resource.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postRoadOccupationStageRoadOccupationStageCollection(requestParameters?: PostRoadOccupationStageRoadOccupationStageCollectionRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<RoadOccupationStageAppEntityRoadOccupationStageRead>;
    public postRoadOccupationStageRoadOccupationStageCollection(requestParameters?: PostRoadOccupationStageRoadOccupationStageCollectionRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpResponse<RoadOccupationStageAppEntityRoadOccupationStageRead>>;
    public postRoadOccupationStageRoadOccupationStageCollection(requestParameters?: PostRoadOccupationStageRoadOccupationStageCollectionRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpEvent<RoadOccupationStageAppEntityRoadOccupationStageRead>>;
    public postRoadOccupationStageRoadOccupationStageCollection(requestParameters?: PostRoadOccupationStageRoadOccupationStageCollectionRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<any> {
        const roadOccupationStage = requestParameters?.roadOccupationStage;

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKey) required
        localVarCredential = this.configuration.lookupCredential('apiKey');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/ld+json',
                'text/html',
                'application/octet-stream'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/ld+json',
            'text/html',
            'application/octet-stream'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/road_occupation_stages`;
        return this.httpClient.request<RoadOccupationStageAppEntityRoadOccupationStageRead>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: roadOccupationStage,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
